/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { OptionDto } from './OptionDto';
import {
    OptionDtoFromJSON,
    OptionDtoFromJSONTyped,
    OptionDtoToJSON,
} from './OptionDto';

/**
 * 
 * @export
 * @interface OptionGroupDto
 */
export interface OptionGroupDto {
    /**
     * 
     * @type {string}
     * @memberof OptionGroupDto
     */
    optionGroupId?: string;
    /**
     * 
     * @type {string}
     * @memberof OptionGroupDto
     */
    variantLinkId?: string;
    /**
     * 
     * @type {string}
     * @memberof OptionGroupDto
     */
    selectionType: OptionGroupDtoSelectionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof OptionGroupDto
     */
    productType: OptionGroupDtoProductTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof OptionGroupDto
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof OptionGroupDto
     */
    description: string;
    /**
     * 
     * @type {number}
     * @memberof OptionGroupDto
     */
    maxSelection: number;
    /**
     * 
     * @type {number}
     * @memberof OptionGroupDto
     */
    minSelection: number;
    /**
     * 
     * @type {boolean}
     * @memberof OptionGroupDto
     */
    required: boolean;
    /**
     * 
     * @type {Array<OptionDto>}
     * @memberof OptionGroupDto
     */
    options: Array<OptionDto>;
}


/**
 * @export
 */
export const OptionGroupDtoSelectionTypeEnum = {
    SINGLE_CHOICE: 'SINGLE_CHOICE',
    MULTIPLE_CHOICE: 'MULTIPLE_CHOICE',
    QUANTITY: 'QUANTITY'
} as const;
export type OptionGroupDtoSelectionTypeEnum = typeof OptionGroupDtoSelectionTypeEnum[keyof typeof OptionGroupDtoSelectionTypeEnum];

/**
 * @export
 */
export const OptionGroupDtoProductTypeEnum = {
    STANDALONE: 'STANDALONE',
    ADDON: 'ADDON',
    CUSTOM: 'CUSTOM',
    UPSELL: 'UPSELL',
    VARIANT: 'VARIANT',
    REMOVABLE: 'REMOVABLE',
    RECOMMENDATION: 'RECOMMENDATION'
} as const;
export type OptionGroupDtoProductTypeEnum = typeof OptionGroupDtoProductTypeEnum[keyof typeof OptionGroupDtoProductTypeEnum];


/**
 * Check if a given object implements the OptionGroupDto interface.
 */
export function instanceOfOptionGroupDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "selectionType" in value;
    isInstance = isInstance && "productType" in value;
    isInstance = isInstance && "displayName" in value;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "maxSelection" in value;
    isInstance = isInstance && "minSelection" in value;
    isInstance = isInstance && "required" in value;
    isInstance = isInstance && "options" in value;

    return isInstance;
}

export function OptionGroupDtoFromJSON(json: any): OptionGroupDto {
    return OptionGroupDtoFromJSONTyped(json, false);
}

export function OptionGroupDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OptionGroupDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'optionGroupId': !exists(json, 'optionGroupId') ? undefined : json['optionGroupId'],
        'variantLinkId': !exists(json, 'variantLinkId') ? undefined : json['variantLinkId'],
        'selectionType': json['selectionType'],
        'productType': json['productType'],
        'displayName': json['displayName'],
        'description': json['description'],
        'maxSelection': json['maxSelection'],
        'minSelection': json['minSelection'],
        'required': json['required'],
        'options': ((json['options'] as Array<any>).map(OptionDtoFromJSON)),
    };
}

export function OptionGroupDtoToJSON(value?: OptionGroupDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'optionGroupId': value.optionGroupId,
        'variantLinkId': value.variantLinkId,
        'selectionType': value.selectionType,
        'productType': value.productType,
        'displayName': value.displayName,
        'description': value.description,
        'maxSelection': value.maxSelection,
        'minSelection': value.minSelection,
        'required': value.required,
        'options': ((value.options as Array<any>).map(OptionDtoToJSON)),
    };
}

